import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ShiftNames, UserPermission } from 'packages/workspace/modules/algebra/constants';
import { Can } from 'packages/workspace/modules/helpers/contexts/abilities';
import useInternalAdminOnCalls from 'packages/workspace/services/hooks/useInternalOnCalls';
import useAbilitiesStore from 'packages/workspace/services/store/abilities-store';
import { SyntheticEvent, useEffect, useState } from 'react';
import { MdContactPhone } from 'react-icons/md';
import PhoneComponent from './PhoneComponent';
import Box from '@mui/material/Box';
import useInternalOnCalls from 'packages/workspace/services/hooks/useInternalOnCalls';

type InternalOnCallProps = {
  open: boolean;
  onClose: () => void;
};

const InternalAdminOnCall: React.FC<InternalOnCallProps> = ({ open, onClose }) => {
  const { ability } = useAbilitiesStore();
  const [callInitiated, setCallInitiated] = useState<boolean>(false);
  const { data: internalOnCallQuery, isSuccess, isError } = useInternalOnCalls(open && ability.can(UserPermission.ONCALL, ShiftNames.USER), 'admin_oncall');

  useEffect(() => {
    if (!open) {
      setCallInitiated(false);
    }
  }, [open]);

  return (
    <>
      <Can I={UserPermission.ONCALL} a={ShiftNames.USER}>
        <Dialog
          fullWidth
          maxWidth={'sm'}
          open={open}
          onClose={(e: SyntheticEvent) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
        >
          <DialogTitle>Connect To On Call Admin Manager</DialogTitle>
          <DialogContent className="model-center-design">
            <DialogContentText>
              Please call the Administrative Line when you're calling out sick, requesting a debrief after a tough chat/call, or you're requesting to use a call/no-show
            </DialogContentText>
            <Box
              component="span"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
              }}
            >
              {isSuccess && internalOnCallQuery && !callInitiated && (
                <>
                  <Button className="mt-5" color="primary" variant="contained" size="large" onClick={() => setCallInitiated(true)}>
                    Connect
                  </Button>
                </>
              )}
              {callInitiated && internalOnCallQuery && (
                <PhoneComponent
                  call_message="You are now connecting with the On Call Admin Manager"
                  call_complete_message="Call with On Call Admin Manager is now complete, You can now close this window."
                  client_phone={internalOnCallQuery.phone}
                  force_disconnect={false}
                  token={internalOnCallQuery.token}
                  phone={internalOnCallQuery.phone}
                  additionalParams={{ action: 'direct-admin-line' }}
                />
              )}
              {isError && <span>Something Went Wrong, Please Close this and try again</span>}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <MdContactPhone className="mr-1 text-base" />
        <span className="text-xs">Admin Call</span>
      </Can>
    </>
  );
};

export default InternalAdminOnCall;
